import { Box, Button, Collapse, Stack, Typography } from "@mui/material";
import { CalendarContentProps } from "./Calendar.types";
import dayjs from "dayjs";
import { DeleteOutlineTwoTone, EditOutlined, KeyboardArrowDown } from "@mui/icons-material";
import { ReactNode } from "react";
import JobForm from "./Form";
import { COLOR } from "../../../utils/colors";
import { getJobTypeLabel, getRepeatTypeLabel } from "../_function/common";
import { ListScheduleCleaningProjection } from "../../../hooks/scheduled_jobs/index.type";
import { getCalendarColorCode } from "./Calendar";
import { getCleaningTypeLabel, useListAvailableZones } from "../../../hooks/cleaning";
import { getProfile } from "../../../utils/api";
import { ZoneType } from "../../../hooks/cleaning/index.type";
import { MapType } from "../../../hooks/map.type";

export default function ShowDataCard({
  content,
  onClickContent,
  appendNode,
  selectedJobId,
  isEdit,
  onCancelEdit,
  onSaveEdit,
  onEdit,
  onDelete,
  zoneOptions,
  listMaps,
  ...props
}: {
  content?: CalendarContentProps | ListScheduleCleaningProjection,
  onClickContent?: (data: CalendarContentProps | ListScheduleCleaningProjection) => void,
  selectedJobId?: string,
  isEdit?: boolean,
  appendNode?: ReactNode,
  onCancelEdit?: () => void,
  onSaveEdit?: () => void,
  onEdit?: (data: CalendarContentProps | ListScheduleCleaningProjection) => void,
  onDelete?: (data: CalendarContentProps | ListScheduleCleaningProjection) => void,
  zoneOptions: ZoneType[],
  listMaps: MapType[]
}) {

  const isCleaningJob = !!content && (content as any)?.job_type === 'cleaning_job'

  const findZonelevel = (zone_id: string) => {
    const res = listMaps.find((map) => {
      const findedZone = zoneOptions.find((item) => item.uuid === zone_id)
      if (!findedZone) {
        return false
      }

      return map.map_uuid === findedZone.map
    })?.map_level

    if (!res) {
      return ""
    }

    return "Level " + res
  }

  return content ? (
    <div
      {...props}
      style={{
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer'
      }}
      onClick={() => onClickContent?.(content)}
    >
      <div
        style={{
          padding: '8px',
          border: `1px solid ${getCalendarColorCode((content as any).job_type).backgroundColor}4D`,
          borderRadius: '6px'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }}
        >
          <Typography sx={{
            fontSize: '14px',
            // color: content.bgColor,
            color: getCalendarColorCode((content as any).job_type).backgroundColor || COLOR.accent.green,
            fontWeight: 600,
            flex: 'auto'
          }}>
            {content.title || (content?.id)}
          </Typography>
          <Typography
            sx={{
              fontSize: '12px',
              color: '#9ca3af'
            }}
          >
            {dayjs.unix(((content as CalendarContentProps)?.timestamp || (content as ListScheduleCleaningProjection)?.start_timestamp)).format("HH:mm")}
          </Typography>
          {
            appendNode
          }
        </div>
        {
          content && (
            <Collapse in={selectedJobId === content.id + '-' + ((content as CalendarContentProps)?.timestamp || (content as ListScheduleCleaningProjection)?.start_timestamp)}>
              {isEdit ? (
                <JobForm isEdit form={content} onCancelEdit={() => onCancelEdit?.()} onEdit={() => onSaveEdit?.()} />
              ) : (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '2px'
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* <div>
                              <Typography
                                fontSize={12}
                                color={COLOR.gray[400]}
                              >
                                Job Id
                              </Typography>
                              <Typography
                                fontSize={14}
                                fontWeight={600}
                                color={COLOR.gray[800]}
                              >
                                {content.jobDetail.job_id}
                              </Typography>
                            </div> */}
                  <div >
                    <Typography
                      fontSize={12}
                      color={COLOR.gray[400]}
                    >
                      Description
                    </Typography>
                    <Typography
                      fontSize={14}
                      fontWeight={600}
                      color={COLOR.gray[800]}
                    >
                      {content.description || '-'}
                    </Typography>
                  </div>
                  <div >
                    <Typography
                      fontSize={12}
                      color={COLOR.gray[400]}
                    >
                      Task Type
                    </Typography>
                    <Typography
                      fontSize={14}
                      fontWeight={600}
                      color={COLOR.gray[800]}
                    >
                      {getJobTypeLabel((content as CalendarContentProps)?.job_type)}
                    </Typography>
                  </div>
                  {!isCleaningJob && (
                    <>
                      <div >
                        <Typography
                          fontSize={12}
                          color={COLOR.gray[400]}
                        >
                          Robot
                        </Typography>
                        <Typography
                          fontSize={14}
                          fontWeight={600}
                          color={COLOR.gray[800]}
                        >
                          {(content as CalendarContentProps).robot_name || '-'}
                        </Typography>
                      </div>

                      <div>
                        <Typography
                          fontSize={12}
                          color={COLOR.gray[400]}
                        >
                          Sender Name
                        </Typography>
                        <Typography
                          fontSize={14}
                          fontWeight={600}
                          color={COLOR.gray[800]}
                        >
                          {(content as CalendarContentProps)?.sender_name}
                        </Typography>
                      </div>
                      <div>
                        <Typography
                          fontSize={12}
                          color={COLOR.gray[400]}
                        >
                          Sender Location
                        </Typography>
                        <Typography
                          fontSize={14}
                          fontWeight={600}
                          color={COLOR.gray[800]}
                        >
                          {(content as CalendarContentProps)?.sender_location}
                        </Typography>
                      </div>
                      <div >
                        <Typography
                          fontSize={12}
                          color={COLOR.gray[400]}
                        >
                          Recipient Name
                        </Typography>
                        <Typography
                          fontSize={14}
                          fontWeight={600}
                          color={COLOR.gray[800]}
                        >
                          {(content as CalendarContentProps)?.recipient_name}
                        </Typography>
                      </div>

                      <div >
                        <Typography
                          fontSize={12}
                          color={COLOR.gray[400]}
                        >
                          Delivery Location
                        </Typography>
                        <Typography
                          fontSize={14}
                          fontWeight={600}
                          color={COLOR.gray[800]}
                        >
                          {(content as CalendarContentProps)?.recipient_location}
                        </Typography>
                      </div>
                    </>
                  )}
                  {
                    isCleaningJob && (
                      <>
                        <div >
                          <Typography
                            fontSize={12}
                            color={COLOR.gray[400]}
                          >
                            Zone(s)
                          </Typography>
                          <Stack>
                            {(content as ListScheduleCleaningProjection)?.zone?.map((item, index) => (
                              <Box
                                key={index}
                                sx={{
                                  p: '2px',
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}>
                                <Typography
                                  fontSize={14}
                                  fontWeight={600}
                                  color={COLOR.gray[800]}

                                >
                                  {findZonelevel(item.zone_uuid) + " " + (item.zone_name || "-")}
                                </Typography>
                              </Box>
                            ))}
                            {(content as ListScheduleCleaningProjection).zone?.length === 0 && (
                              <Typography
                                fontSize={14}
                                fontWeight={600}
                                color={COLOR.gray[800]}

                              >
                                -
                              </Typography>
                            )}
                          </Stack>
                        </div>
                        <div >
                          <Typography
                            fontSize={12}
                            color={COLOR.gray[400]}
                          >
                            Cleaning Mode:
                          </Typography>
                          <Typography
                            fontSize={14}
                            fontWeight={600}
                            color={COLOR.gray[800]}
                            sx={{ textTransform: 'capitalize' }}
                          >
                            {getCleaningTypeLabel((content as ListScheduleCleaningProjection).cleaning_type) || "-"}
                          </Typography>
                        </div>
                      </>
                    )
                  }
                  <div >
                    <Typography
                      fontSize={12}
                      color={COLOR.gray[400]}
                    >
                      Start On
                    </Typography>
                    <Typography
                      fontSize={14}
                      fontWeight={600}
                      color={COLOR.gray[800]}
                    >
                      {dayjs.unix((content as CalendarContentProps)?.timestamp || (content as ListScheduleCleaningProjection)?.start_timestamp).format("DD MMM YYYY HH:mm")}
                    </Typography>
                  </div>
                  {/* <div >
                                  <Typography
                                    fontSize={12}
                                    color={COLOR.gray[400]}
                                  >
                                    Status
                                  </Typography>
                                  <Typography
                                    fontSize={14}
                                    fontWeight={600}
                                    color={COLOR.gray[800]}
                                  >
                                    {content.jobDetail.status}
                                  </Typography>
                                </div> */}
                  <div>
                    <Typography
                      fontSize={12}
                      color={COLOR.gray[400]}
                    >
                      Repeat
                    </Typography>
                    <Typography
                      fontSize={14}
                      fontWeight={600}
                      color={COLOR.gray[800]}
                      textTransform={"capitalize"}
                    >
                      {getRepeatTypeLabel(content.recurring_type)}
                    </Typography>
                  </div>
                  {/* <div>
                                <div>
                                  <Typography>
                                    Repeat Type
                                  </Typography>
                                  <Select>
                                    <MenuItem value="All">All Robots</MenuItem>
                                  </Select>
                                </div>
                              </div> */}
                  <div style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '4px',
                    marginTop: '4px'
                  }}>
                    <Button
                      onClick={() => onEdit?.(content)} sx={{ width: '100%', flex: 'auto' }} variant="outlined" disableElevation>
                      <EditOutlined fontSize="small" />
                      Edit
                    </Button>
                    <Button onClick={() => onDelete?.(content)} sx={{ width: '100%', flex: 'auto' }} color="error" variant="outlined" disableElevation>
                      <DeleteOutlineTwoTone fontSize="small" />
                      Delete
                    </Button>
                  </div>

                </div>
              )}
            </Collapse>
          )
        }
      </div>
    </div>
  ) : (<></>)
}